module.exports = require("normalizr");